<div class="flex full-width align-items-center">
    <lib-rating-star
        *ngFor="let index of [1, 2, 3, 4, 5]"
        [display]="rating >= index ? 'fill' : 'empty'"
        [isClickable]="true"
        (onStarClick)="onClick(index)"
        [size]="35" />
    <p *ngIf="displayRatingAmountLabel && rating > 0" class="text-title">
        {{ rating }}
        <ng-container [ngPlural]="rating">
            <ng-template ngPluralCase="=1">star</ng-template>
            <ng-template ngPluralCase="other">stars</ng-template>
        </ng-container>
        <ng-container *ngIf="rating < 5">
            {{ ratingAmountLabel }}
        </ng-container>
    </p>
</div>
